<template>
    <van-popup v-model="show" @click-overlay="close">
        <div class="tips_pop">
            <div class="tips_top">
                <div class="tips_title">{{ $t("lang.tips") }}</div>
                <div class="tips_close" @click="close">
                    <i class="iconfont icon-s-cuowu-guanbi" @click="close"></i>
                </div>
            </div>
            <div class="tips_box">
                <slot>
                    <div>{{ tips }}</div>
                    <div v-if="tips2" class="tips2">{{ tips2 }}</div>
                </slot>
            </div>
            <div class="tips_footer" @click="confirm">
                {{ $t("lang.confirm") }}
            </div>
        </div>
    </van-popup>
</template>

<script>
export default {
    props: {
        tips: {
            type: String,
            default: ''
        },
        tips2: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            show: false
        }
    },
    methods: {
        close() {
            this.show = false
        },
        open() {
            this.show = true
        },
        confirm() {
            this.close()
            this.$emit('confirm')
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.van-popup {
    background: transparent;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 100%;
}
.tips_pop {
    padding: .31rem;
    box-sizing: border-box;
    width: 6.9rem;
    background: $bg-popup-color;
    border-radius: .2rem;
    margin: 0 auto;
    padding-bottom: .06rem;
    height: auto;

    .tips_top {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .tips_title {
            font-weight: 400;
            font-size: .28rem;
            color: var(--aurora-ink);
            font-size: .24rem;
        }

        .tips_close {
            width: .42rem;
            height: .42rem;
            cursor: pointer;
        }
    }

    .tips_box {
        margin: .4rem auto;
        color: var(--aurora-accent);
        font-size: .24rem;

        .tips2{
            margin-top: .2rem;
        }
    }

    .tips_footer {
        width: 100%;
        box-sizing: border-box;
        height: .9rem;
        border-top: .01rem solid var(--aurora-line);
        line-height: .91rem;
        text-align: center;
        font-size: .3rem;
        font-weight: bold;
        color: var(--aurora-ink);
        cursor: pointer;
    }
}
</style>
